// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"noUu1yN43M7AS0HgC2AK7","thumbnail":"_2r8-og3Pq2DGd3TuRSCnTM","link":"_1oJtLZcjpNFhqXmka-dY-6","instagramIcon":"WxqRphfTyAJyFRw-Pu72C"};